import { http } from "@/api/config.js";
import qs from "qs";

let cookieList = document.cookie ? document.cookie.split(";") : [];
let cookies = {};
cookieList.forEach((item) => {
  if (!cookies[item.split("=")[0].trim()])
    cookies[item.split("=")[0].trim()] = item.split("=")[1];
});

export const getReportListApi = (data) => {
  return http({
    url: `/gz-reports/users/${cookies["user-idcon"]}?${qs.stringify(data, {
      arrayFormat: "repeat",
    })}`,
    method: "GET",
  });
};
